// extracted by mini-css-extract-plugin
module.exports = {"container":"Label_container__HA_vh","label":"Label_label__3Vu1g","dot":"Label_dot__sjamR","text":"Label_text__pGfgc"};